// window.Popper = require('popper.js').default;
// window.$ = window.jQuery = require('jquery');

// window.bootstrap = require('bootstrap');
window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = window.csrfToken;
window.axios.defaults.headers.common['locale'] = window.locale;


window.Vue = require('vue').default;
window.Vuex = require('vuex');
window._ = require('lodash');

import Notifications from 'vue-notification'

Vue.prototype._ = _
Vue.use(Vuex);
Vue.use(Notifications);

window.EventBus = new Vue();

import markdownit from 'markdown-it'
window.markdownit = markdownit;

var components = {
    'search-component': 'SearchComponent',
    'cart-component': 'CartComponent',
    'cart-summary-component': 'CartSummaryComponent',
    'cart-vouchers-component': 'CartVouchersComponent',
    'product-main-component': 'ProductMainComponent',
    // 'account-rewards-points-component': 'AccountRewardsPointsComponent',
    'add-to-cart-component': 'AddToCartComponent',
    'add-to-cart-buttons-component': 'AddToCartButtonsComponent',
    'notifications-component': 'NotificationsComponent',
    'cart-dropdown-component': 'CartDropdownComponent',
    'checkout-component': 'CheckoutComponent',
    'product-block-component': 'ProductBlockComponent',
    'wishlist-icon-component': 'WishlistIconComponent',
    'wishlist-nav-component': 'WishlistNavComponent',
    'wishlist-component': 'WishlistComponent',
    'blog-component': 'BlogComponent',
    'reviews-component': 'ReviewsComponent',
    'addresses-component': 'AddressesComponent',
    'bundle-block-component': 'BundleBlockComponent',
    // 'locations-map-component': 'LocationsMapComponent',
    'promo-watermark-component': 'PromoWatermarkComponent',
    'payment-component': 'checkout/PaymentComponent',
    'personal-details-component': 'checkout/PersonalDetailsComponent',
    'shipping-details-component': 'checkout/ShippingDetailsComponent',
    // 'delivery-date-selection-component': 'checkout/DeliveryDateSelectionComponent',
    'ai-chatbox-component': 'AiChatboxComponent',
    'ai-chatbox-link-component': 'AiChatboxLinkComponent',
    'product-video-component': 'ProductVideoComponent',
}
Object.keys(components).forEach(key => {
    try {
        Vue.component(key, require('./components/'+components[key]+'.vue').default);
    } catch (e) {
        Vue.component(key, require('../../Modules/Shop/Resources/assets/js/components/'+components[key]+'.vue').default);
    }
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.mixin({
    methods: {
        url(path) {
            return app_url+'/'+(locale != config.default_locale ? locale+'/' : '')+path
        },
        amountWithCurrency(amount, defaultCurrency = false) {
            if (window.currency_default.decimals) {
                amount = amount / 100
            }

            if (!defaultCurrency) {
                amount = this.roundToDecimalPlaces(amount*parseFloat(window.currency.rate), window.currency.decimals)
            }
            let currency = defaultCurrency ? window.currency_default : window.currency
            amount = this.numberFormat(amount, currency)
            if (window.language_number_format[window.locale]['position'] == 'left') {
                return window.currency.symbol+amount
            } else {
                return amount+window.currency.symbol
            }
        },
        numberFormat(number, currency) {
            return number.toLocaleString(locale, { minimumFractionDigits: currency.decimals })
        },
        roundToDecimalPlaces(value, decimalPlaces) {
            let multiplier = Math.pow(10, decimalPlaces);
            return Math.round(value * multiplier) / multiplier;
        },
        stripTags(str) {
            return str.replace(/(<([^>]+)>)/gi, "")
        },
        truncateText(text, length = 60, omission = '[...]') {
            return _.truncate(text, {length: length, omission: omission})
        },
        __(file, ref, replace = {})
        {
            var translation = window.t[file][ref]

            if (replace) {
                for (var placeholder in replace) {
                    translation = translation.replace(`:${placeholder}`, replace[placeholder]);
                }
            }
            return translation;
        },
        pluck(array, key) {
            return array.map(o => o[key]);
        },
        imageSmall(str) {
            return str.replace('.jpg', '-sm.jpg').replace('.png', '-sm.png')
        },
        nl2br(text) {
          return text.replace(/\n/g, '<br>');
        },
        notify(data) { // in order to override for each project
            // eg. {text: 'text', type: 'success'}
            Vue.notify(data)
        },
        // a function to change iso date format to user locale readable format
        formatDate(date) {
            return new Date(date).toLocaleDateString(locale, { year: 'numeric', month: 'long', day: 'numeric' })
        }
    }
})

const share = document.querySelector('#share');
// Share must be triggered by "user activation"
if(share) {
    share.addEventListener('click', async (event) => {
        event.preventDefault()
        try {
            await navigator.share({
                title: share.dataset.title,
                text: share.dataset.description,
                url: share.dataset.url
            })
        } catch(err) {
            console.log(err);
        }
    });
}
const shareCopy = document.querySelector('#share-copy');
if(shareCopy) {
    shareCopy.addEventListener('click', async (event) => {
        event.preventDefault()
        try {
            await navigator.clipboard.writeText(shareCopy.dataset.url).then(function() {
                Vue.notify({text: t.global.copy_success, type: 'success'})
            });
        } catch (e) {
            console.log(e);
        }
    })
}

// import Alpine from 'alpinejs'
// window.Alpine = Alpine
// Alpine.start()
